namespace e5 {
    export interface AccessibleToolbarOptions {
        itemSelector?: string;
        disableSelectable?: boolean;
        horzNavigation?: boolean;
        labelAttribute?: string;
        emulateClick?: boolean;
        ariaRole?: string;
        keepSelection?: boolean;
    }

    export class AccessibleToolbar<Item extends HTMLElement = HTMLElement>{

        private _itemSelector: string;
        private _itemSelectorExtension: string = "";
        private _itemFilter: string = ":visible";
        private _horzNavigation: boolean = false;
        private _labelAttribute: string;
        private _emulateClick: boolean = false;
        private _keepSelection: boolean = true;

        constructor(public element: HTMLElement, options: AccessibleToolbarOptions = null) {

            options = e5.ObjectUtil.extend({
                itemSelector: ".item",
                disableSelectable: false,
                horzNavigation: false,
                labelAttribute: "data-label",
                emulateClick: false,
                ariaRole: "toolbar",
                keepSelection: true
            } as AccessibleToolbarOptions, options);

            this._labelAttribute = options.labelAttribute;
            this._itemSelector = options.itemSelector;
            this._horzNavigation = options.horzNavigation;
            this._emulateClick = options.emulateClick;
            this._keepSelection = options.keepSelection;

            element.setAttribute("role", options.ariaRole);
            element.tabIndex = 0;
            $(this._itemSelector, this.element).attr("tabindex", "-1");

            if (options.disableSelectable) {
                this._itemSelectorExtension = ":not([aria-disabled=true])";
            }

            //Focus the first item when the container is focused.
            //If the container receives focus for the first time,
            //just focus the first item.
            this.element.addEventListener("focus", () => {

                if (!this._keepSelection) {
                    this.focus(this.first());
                    return;
                }

                // if (!element.id) { }
                // else if (this.selected()) {
                //     // console.log("BY selected", element.id);
                // }
                // else if (this.current()) {
                //     // console.log("BY current", element.id);
                // }
                // else if (this.first()) {
                //     // console.log("BY first", element.id);
                // }
                // else {
                //     console.log("BY NONE", element.id, this.first());
                // }
                // this.element.scrollIntoView({});
                // setTimeout(() => {
                this.focus(this.selected() || this.current() || this.first());
                // }, 100);
            });

            $(this.element).on("mousedown", this._itemSelector, (e) => {
                // e.preventDefault();
                this.focus(e.currentTarget as Item);
            });

            //Enable Shift-Tab (Backward Tabbing)
            $(this.element).on("focus blur", this._itemSelector, (e) => {
                if (e.originalEvent.type == "focus") {
                    this.element.tabIndex = -1;
                    e.currentTarget.tabIndex = 0;
                    // var selected = this.selected();
                    // if (selected) {
                    //     selected.classList.remove("selected");
                    // }
                    // e.currentTarget.classList.add("selected");
                    this.select(e.currentTarget as Item);
                    // this.element.classList.add("focused");
                } else if (e.originalEvent.type == "blur") {
                    this.element.tabIndex = 0;
                    e.currentTarget.tabIndex = -1;
                    // this.element.classList.remove("focused");
                }
            });

            //Handle keyboard control.
            this.element.addEventListener("keydown", (e) => {
                if (e.defaultPrevented) {
                    return; // Should do nothing if the default action has been cancelled
                }

                // var keyCode:number = 0;
                // if(e.key){
                //     keyCode = e.key.charCodeAt(0);
                // } else {
                //     keyCode = e.which || e.charCode || e.keyCode || 0;
                // }

                var keyCode: number = e.keyCode;

                if (!keyCode) {
                    return;
                }

                if ((e.altKey || e.ctrlKey)
                    || (e.shiftKey && keyCode != 9)) {
                    return;
                }

                // console.log(keyCode, e.key);

                switch (keyCode) {
                    case 37:  // Left arrow
                        if (this._horzNavigation) {
                            // var focusableBefore = $(this.element).prevAll("[tabindex]").get(0);
                            // console.log("AHHH", focusableBefore);
                            // if(focusableBefore){
                            //     focusableBefore.focus();
                            // }

                            var q = 'button:not([tabindex="-1"]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
                            if (document.activeElement) {
                                var focusable = document.querySelectorAll(q);
                                var index = Array.prototype.indexOf.call(focusable, document.activeElement);

                                if (index != -1) {
                                    var item = focusable.item(index - 1) as HTMLElement;
                                    if (item) {
                                        item.focus();
                                    }
                                }
                            }

                            break;
                        }
                    case 38:  // Up arrow
                        e.preventDefault();
                        this.focus(this.prev() || this.last());
                        break;
                    case 39: // Right arrow
                        if (this._horzNavigation) {
                            var current = this.current();
                            if (current) {
                                $(current).trigger("click");
                            }
                            break;
                        }
                    case 40: // Down arrow
                        e.preventDefault();
                        this.focus(this.next() || this.first());
                        break;
                    case 36: // Home / Pos1
                        e.preventDefault();
                        this.focus(this.first());
                        break;
                    case 35: // PageDown / Ende
                        e.preventDefault();
                        this.focus(this.last());
                        break;
                    case 13: // Enter
                    case 32: // Space
                        if (this._emulateClick) {
                            e.preventDefault();
                            //TODO: trigger
                            var current = this.current();
                            if (current) {
                                current.click();
                            }
                            break;
                        }
                    default:
                        var chr = String.fromCharCode(keyCode);
                        var find = this.find(chr);
                        if (find)
                            this.focus(find);
                        break;
                }
            });
        }

        public clear(): void {
            $<Item>(this._itemSelector + ".selected" + this._itemSelectorExtension, this.element).removeClass("selected");
            $<Item>(this._itemSelector + "[tabindex=0]" + this._itemSelectorExtension, this.element).attr("tabindex", "-1");
        }

        public select(item: Item): void {
            var selected = $<Item>(this._itemSelector + ".selected", this.element).first().get(0);
            if (selected && selected != item) {
                selected.classList.remove("selected");
            }
            if (item)
                item.classList.add("selected");
        }

        public focus(item: Item): void {
            if (!item) {
                return;
            }

            // if(document.activeElement == item){
            //     $(item).trigger("focus");
            // } else {
            item.focus();
            // }
        }

        public find(char: string): Item {
            // char = char.toLowerCase();
            var current = this.current();
            var item = null;
            var sel = this._itemSelector + `[${this._labelAttribute}^="${char.toLowerCase()}"]` + this._itemSelectorExtension;
            sel += ", " + this._itemSelector + `[${this._labelAttribute}^="${char.toLocaleUpperCase()}"]` + this._itemSelectorExtension
            // console.log("FIND", char);
            if (current) {
                item = $<Item>(current).nextAll(sel).filter(this._itemFilter).first().get(0);
            }
            if (!item) {
                return $<Item>(sel, this.element).filter(this._itemFilter).first().get(0);
            }
            return item;
        }

        public first(): Item {
            return $<Item>(this._itemSelector + this._itemSelectorExtension, this.element).filter(this._itemFilter).first().get(0);
        }

        public last(): Item {
            return $<Item>(this._itemSelector + this._itemSelectorExtension, this.element).filter(this._itemFilter).last().get(0);
        }

        public current(): Item {
            return $<Item>(this._itemSelector + "[tabindex=0]" + this._itemSelectorExtension, this.element).filter(this._itemFilter).first().get(0);
        }

        public selected(): Item {
            return $<Item>(this._itemSelector + ".selected" + this._itemSelectorExtension, this.element).filter(this._itemFilter).first().get(0);
        }

        public prev(current: Item = this.current()): Item {
            return $<Item>(current).prevAll(this._itemSelector + this._itemSelectorExtension).filter(this._itemFilter).get(0);
        }

        public next(current: Item = this.current()): Item {
            return $<Item>(current).nextAll(this._itemSelector + this._itemSelectorExtension).filter(this._itemFilter).get(0);
        }

        public dispose(): void {
            this.element = null;
            this._horzNavigation = null;
            this._itemFilter = null;
            this._itemSelector = null;
            this._itemSelectorExtension = null;
        }
    }
}